import React, { useState } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { classNames } from 'lib/util';
import { usePopper } from 'react-popper';
import {
  AnnotationIcon,
  DotsHorizontalIcon,
  TrashIcon,
} from '@heroicons/react/outline';

export default function TranscriptRowMenu({
  onDelete,
  onTranscribe,
}: {
  onDelete: () => void;
  onTranscribe?: () => void;
}) {
  const [referenceElement, setReferenceElement] =
    useState<HTMLButtonElement>(null);
  const [popperElement, setPopperElement] = useState<HTMLDivElement>(null);

  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: 'bottom-end',
    strategy: 'fixed',
    modifiers: [{ name: 'offset', options: { offset: [0, 10] } }],
  });

  return (
    <Menu as="div" className="relative inline-flex text-left">
      <Menu.Button
        className="focus:shadow-outline-blue inline-flex w-full justify-center rounded-md bg-white text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out hover:text-gray-500 active:bg-gray-50 active:text-gray-800"
        ref={setReferenceElement}
      >
        <DotsHorizontalIcon
          className="h-10 w-10 p-2 text-gray-500"
          aria-hidden="true"
        />
      </Menu.Button>

      <div
        className="w-48 z-10"
        style={styles.popper}
        {...attributes.popper}
        ref={setPopperElement}
      >
        <Transition
          enter="transition duration-100 ease-out"
          enterFrom="transform scale-95 opacity-0"
          enterTo="transform scale-100 opacity-100"
          leave="transition duration-75 ease-out"
          leaveFrom="transform scale-100 opacity-100"
          leaveTo="transform scale-95 opacity-0"
        >
          <Menu.Items className="divide-y divide-gray-100 rounded-md border border-gray-200 bg-white shadow-lg outline-none">
            <div className="py-1">
              <Menu.Item>
                {({ active }) => (
                  <>
                    <button
                      type="button"
                      className={classNames(
                        active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                        'flex items-center w-full text-left px-4 py-2 text-sm'
                      )}
                      onClick={() => onDelete()}
                    >
                      <TrashIcon
                        className="mr-2 h-5 w-5 text-blue-400"
                        aria-hidden="true"
                      />
                      Delete
                    </button>
                    {onTranscribe && (
                      <button
                        type="button"
                        className={classNames(
                          active
                            ? 'bg-gray-100 text-gray-900'
                            : 'text-gray-700',
                          'flex items-center w-full text-left px-4 py-2 text-sm'
                        )}
                        onClick={() => onTranscribe()}
                      >
                        <AnnotationIcon
                          className="mr-2 h-5 w-5 text-blue-400"
                          aria-hidden="true"
                        />
                        Transcribe Again
                      </button>
                    )}
                  </>
                )}
              </Menu.Item>
            </div>
          </Menu.Items>
        </Transition>
      </div>
    </Menu>
  );
}
